// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".group-tags {\n  display: inline-block;\n  margin: 0px 5px;\n}\n\n.input-field {\n  max-width: 300px;\n}\n\n.dropdown {\n  display: block !important;\n}\n\n.dropdown-menu {\n  width: -webkit-fill-available !important;\n}", ""]);
// Exports
module.exports = exports;
